import Navbar from "@/components/Mobile/Navbar.vue";
import Dashboard from "@/views/private/Dashboard.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/dashboard",
        name: RouteEnum.DASHBOARD,
        components: {
            default: Dashboard,
            footer: Navbar
        }
    },
]
